/**
 * The role catalogue, in one place.
 *
 * UsersPage, SuperAdminPage and ProfilePage each carried their own hand-typed
 * list of <option> values and their own copy of the sub-account set, so a role
 * added or renamed on the backend had to be found in three files — and after
 * TRANSIT was merged into LOGISTIQUE, two of them still offered it.
 *
 * `scope` is what the role is allowed to reach, in the operator's words. It is
 * shown next to the name when picking a role, because "Gérant" and
 * "Gestionnaire" are not self-explanatory to whoever creates the account.
 */

import { libelle, tableAvecRepli } from './libelles';

export const ROLES = [
  { value: 'SUPER_ADMIN', label: 'Super admin', scope: 'Gestion de la plateforme.', platformOnly: true },
  { value: 'ADMIN_SOCIETE', label: 'Administrateur', scope: 'Gère les comptes et les profils dans la licence de la société.' },
  { value: 'PERSONNEL', label: 'Personnel', scope: 'Droits définis par un profil créé par l’administrateur.' },
  { value: 'CHAUFFEUR', label: 'Chauffeur', scope: 'Application mobile : sa mission et ses preuves terrain.' },
  { value: 'CLIENT_PORTAL', label: 'Portail client', scope: 'Missions et documents explicitement partagés.' },
];

/**
 * Roles that sign in with an access code instead of email + password.
 * LOGISTIQUE n'en fait plus partie: rôle de bureau, il se connecte au site par
 * e-mail et mot de passe (même liste côté serveur, `api/v1/users.py`).
 */
export const SUB_ACCOUNT_ROLES = new Set([
  'MAINTENANCE',
  'GESTIONNAIRE_STATION',
  'GERANT_STATION',
  'AGENT_STATION',
  'CONTROLEUR_CARBURANT',
  'CHAUFFEUR',
]);

/** Roles whose reach is the whole organisation, so per-user rights do not apply. */
export const UNRESTRICTABLE_ROLES = new Set(['SUPER_ADMIN', 'ADMIN_SOCIETE']);

// Alias de `LIBELLES.userRole`: un rôle inconnu se lit quand même en français.
export const ROLE_LABELS = tableAvecRepli('userRole', ROLES.map((role) => role.value));

export const roleLabel = (value) => libelle('userRole', value);

/** What an ADMIN_SOCIETE may hand out — everything except the platform roles. */
export const assignableRoles = (isSuperAdmin) =>
  ROLES.filter((role) => isSuperAdmin || !role.platformOnly);
